// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fG","body_styleRed":"c-a_fH"};